export { default as createTableReducer } from './createTableReducer';
export { default as selectionReducer } from './selectionReducer';



// WEBPACK FOOTER //
// ./webpack/assets/javascripts/react_app/components/common/table/reducers/index.js